import { useSearchParams } from "react-router-dom";

export const usePagination = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const currentPage = Number(searchParams.get("page")) || 1;
  const secondCurrentPage = Number(searchParams.get("page2")) || 1;

  const setPage = (newPage: number) => {
    setSearchParams({
      ...Object.fromEntries(searchParams),
      page: String(newPage),
    });
  };
  const setFirstPage = (newPage: number) => {
    setSearchParams({
      ...Object.fromEntries(searchParams),
      page: String(newPage),
      page2: String(1),
    });
  };
  const setSecondPage = (newPage: number) => {
    setSearchParams({
      ...Object.fromEntries(searchParams),
      page: String(currentPage || 1),
      page2: String(newPage),
    });
  };

  return {
    currentPage,
    secondCurrentPage,
    setPage,
    setFirstPage,
    setSecondPage,
  };
};
